import lifeStyle0 from './life-style0.png'
import lifeStyle1 from './life-style1.png'
import lifeStyle2 from './life-style2.png'
import lifeStyle3 from './life-style3.png'
import lifeStyle4 from './life-style4.png'
import lifeStyle5 from './life-style5.png'
import lifeStyle6 from './life-style6.png'
import lifeStyle7 from './life-style7.png'

let lifeStyleList = [
    {
        name: 'ホテル',
        nameEn: 'HOTEL',
        image: lifeStyle0 
    },
    {
        name: '空港',
        nameEn: 'AIRPORT',
        image: lifeStyle1
    },
    {
        name: '会社',
        nameEn: 'COMPANY',
        image: lifeStyle2 
    },
    {
        name: '自宅',
        nameEn: 'STAY AT HOME',
        image: lifeStyle3
    },
    {
        name: '移動中',
        nameEn: 'DURING THE MOVE',
        image: lifeStyle4 
    },
    {
        name: '出張先',
        nameEn: 'BUSSNESS',
        image: lifeStyle5
    },
    {
        name: '旅行',
        nameEn: 'TRAVEL',
        image: lifeStyle6 
    },
    {
        name: '飲食店',
        nameEn: 'RESTAURANT',
        image: lifeStyle7
    },
]
export default lifeStyleList